export default __webpack_public_path__ + "static/media/5.3e78b748.png";